"use strict"

angular.module("customer")
.service("UserManagementService", function(
    $resource, $http, $state, FlashBag, gettextCatalog, ModalService, UserService, appConfig
) {
    var resource = $resource(appConfig.API_SERVER + "/auth/customer/users/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        update: {
            method: "PUT",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var transferOwnershipResource = $resource(appConfig.API_SERVER + "/auth/customer/transfer-ownership/:id/", {id: "@id"}, {
        post: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var ownerResource = $resource(appConfig.API_SERVER + "/auth/customer/owner/", {}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var sendUserInvitationResource = $resource(appConfig.API_SERVER + "/auth/customer/send-user-invitation/:id/", {id: "@id"}, {
        post: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.create = function(data) {
        var instance = new resource(data);
        return instance.$create();
    };

    this.query = function(params) {
        return resource.query(params);
    };

    this.get = function(id) {
        return resource.get({id: id});
    };

    this.getOwner = function() {
        return ownerResource.get({});
    };

    this.update = function(instance) {
        return instance.$update();
    };

    this.delete = function(instance) {
        var params = {
            id: instance.id,
            password: instance.password
        };
        return resource.delete(params).$promise;
    };

    this.transferOwnership = function(userCustomerId) {
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Transfer Ownership"),
                    message: gettextCatalog.getString("Do you want really want to transfer your ownership?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return;
                }
                executeTransferOwnership(userCustomerId).then(UserService.refreshCurrentUser).then(function onSuccess() {
                    var message = gettextCatalog.getString("Ownership was transferred successfully.");
                    FlashBag.success(message, true);
                    $state.reload();
                });
            });
        });
    };

    function executeTransferOwnership(userCustomerId) {
        var instance = new transferOwnershipResource({id: userCustomerId});
        return instance.$post();
    }

    this.sendUserInvitation = function(userCustomerId) {
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Send user invitation"),
                    message: gettextCatalog.getString("Do you want to resend the invitation?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return;
                }
                sendUserInvitation(userCustomerId).then(function onSuccess() {
                    var message = gettextCatalog.getString("Invitation was sent successfully.");
                    FlashBag.success(message, true);
                });
            });
        });
    };

    function sendUserInvitation(userCustomerId) {
        var instance = new sendUserInvitationResource({id: userCustomerId});
        return instance.$post();
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-management/user-management.service.js
// module id = 962
// module chunks = 0